<template>
    <v-row dense v-bind="$attrs">
        <v-col cols="12" :class="['body-light label-color', {'error--text': errorBucket.length > 0}]">
            Perfiles Recomendados
        </v-col>
        <v-col cols="12" v-if="loadingProfiles">
            <loading-spinner no-margin-top height="75px" size="25" width="2" />
        </v-col>
        <v-col cols="12" v-else-if="profileOptions.length === 0">
            <v-alert type="warning" dense class="caption-heavy" border="left">
                Aún no se agregan perfiles
            </v-alert>
        </v-col>
        <v-col cols="12">
            <kimsa-button-selector
                :items="profileOptions"
                :value="profiles"
                @change="profiles = $event"
            />
        </v-col>
        <VMessages v-if="details" :value="errorBucket" color="error" class="mt-1"/>
    </v-row>
</template>

<script>
import LoadingSpinner from "@/components/common/LoadingSpinner";
import {VInput} from "vuetify/lib/components";
import KimsaButtonSelector from "@/components/common/inputs/KimsaButtonSelector";

export default {
    name: "ProfileSelector",
    extends: VInput,
    components: {KimsaButtonSelector, LoadingSpinner},
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        rules: {
            type: Array,
            default: () => [],
        },
        details: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            profiles: [],
            profileOptions: [],
            loadingProfiles: false,
        }
    },
    async mounted() {
        const vm = this
        await vm.loadProfiles()
        vm.setDefaults()
    },
    methods: {
        setDefaults () {
            const vm = this
            if(vm.value) vm.profiles = vm.value
        },
        async loadProfiles() {
            const vm = this
            vm.loadingProfiles = true

            let profilesRef = await db.collection('profiles').get()

            vm.profileOptions = profilesRef.docs.map(profile => {
                return {
                    id: profile.id,
                    ...profile.data()
                }
            })

            vm.loadingProfiles = false
        },
        onSelectProfile(profileId) {
            const vm = this
            if(vm.isSelected(profileId)) return vm.profiles = vm.profiles.filter(profile => profile !== profileId)
            vm.profiles.push(profileId)
        },
        isSelected(profileId) {
            const vm = this
            return vm.profiles.find(profile => profile === profileId)
        }
    },
    watch: {
        value() {
            this.setDefaults()
        },
        profiles(val) {
            this.$emit('change', val)
        }
    }

}
</script>

<style scoped>

</style>